import template from './phone-lines-additional.jade';

export default angular
  .module('cian.addForm.phoneLinesAdditional', [])
  .directive('cianAfAboutObjectPhoneLinesAdditional', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService) {
      'ngInject';

      this.isMobile = deviceService.isMobile;

      this.items = [
        {
          text: 'Да',
          value: true,
        },
        {
          text: 'Нет',
          value: false,
        },
      ];
    },
    controllerAs: 'phoneLinesAdditional',
    template,
  })).name;
